import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [CommonModule],
})
export class NgJhipsterModule {
  static forRoot(config: {
    alertAsToast: boolean;
    alertTimeout: number;
  }): ModuleWithProviders<NgJhipsterModule> {
    return {
      ngModule: NgJhipsterModule,
      providers: [],
    };
  }
}
